import { useRef } from 'react'

import { DSToastContainer } from '@vr/ds-react'

import { FormFilter } from '@/compositions/form-filters'
import { FormFilterRef } from '@/compositions/form-filters/ref'
import { GeneralList } from '@/compositions/general-list'
import { useGeneralContext } from '@/contexts/general.context'

const GeneralView = () => {
  const filterFormRef = useRef<FormFilterRef>(null)

  const { setTableData, handleFilter, handleLimitChange } = useGeneralContext()

  const handleClearForm = () => {
    if (filterFormRef.current) {
      filterFormRef.current.clearForm()
      setTableData([])
      handleLimitChange(10)
    }
  }

  return (
    <>
      <DSToastContainer position='top-left' />
      <FormFilter
        ref={filterFormRef}
        onFilters={handleFilter}
        onClear={handleClearForm}
      />

      <GeneralList />
    </>
  )
}

export default GeneralView
